<template>
  <div>
    <document-container
      v-if="template"
      :footer="template.footer()"
      :header="template.header()"
      :logo="logo"
      :tables="tables"
      documentType="report"
    >

      <div v-for="block in template.body()"
           slot="raw-body"
           class="page-block">

        <component
          :is="block.type"
          :data="block"
        ></component>

      </div>

      <report-base-figures
        slot="raw-body"
        :productCurrency="product.added.productQuotedAs"
        :productPriceAsk="product.product.figures.productPrice.useAsk"
        :productPriceBid="product.product.figures.productPrice.useBid"
        :underlyingCurrency="product.added.underlyingQuotedAs"
        :underlyingPrice="product.product.figures.underlyingPrice.useLast"
        :underlyingTimestamp="product.product.figures.underlyingPrice.timestamp"
      ></report-base-figures>

      <product-table-report
        v-for="type in [1,2]"
        :key="type"
        slot="raw-body"
        :data="product"
        :template="template"
        :type="type"
        class="page-block"
      ></product-table-report>

      <div slot="raw-body">
        <payback-text-container
          :added="product.added"
          :product="product.product"
        ></payback-text-container>
      </div>

      <report-development
        v-if="chartData"
        slot="raw-body"
        :chartData="chartData"
        :product="product"
        class="page-block">
      </report-development>

      <div v-if="tables.findTable('past-events').hasRows()"
           slot="raw-body"
           class="page-block">

        <table-report-events
          :table="tables.findTable('past-events')"
        ></table-report-events>

      </div>

      <div v-if="tables.findTable('upcoming-events').hasRows()"
           slot="raw-body"
           class="page-block">

        <table-report-events
          :table="tables.findTable('upcoming-events')"
        ></table-report-events>

      </div>


      <div v-if="template.config.longDisclaimer && template.config.longDisclaimer.body.length > 0" slot="raw-body"
           class=" page-block">

        <textblock
          :data="template.config.longDisclaimer"
        ></textblock>
      </div>

    </document-container>
  </div>
</template>

<script>
import TableReportEvents from '../table/TableReportEvents'
import ProductService from '../../service/ProductService'
import ConfigService from '../../service/ConfigService'
import TemplateService from '../../service/TemplateManager'
import DocumentContainer from '../document/DocumentContainer'
import PaybackTextContainer from './payback/PaybackTextContainer'
import BlockMixin from '../block/BlockMixin'
import ProductTableReport from './BlockProductTableReport'
import ReportDevelopment from './ReportDevelopment.vue'
import {Table} from '../../model/table/Table'
import {TableCollection} from '../../model/table/TableCollection'
import ReportBaseFigures from './ReportBaseFigures.vue'
import TokenService from "../../service/TokenService"

export default {
  components: {
    ReportBaseFigures,
    ReportDevelopment,
    TableReportEvents,
    ProductTableReport,
    DocumentContainer,
    PaybackTextContainer
  },

  name: 'report',

  data() {
    return {
      product: {},
      template: null,
      chartData: null,
      labels: {},
      TableReportEvents,
      tables: {
        type: TableCollection
      },
      token: null
    }
  },

  mixins: [BlockMixin],

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/' + this.environment + '/style/report.css'
        }
      ]
    }
  },

  props: {
    environment: {
      type: String
    },
    dq: {
      type: String
    },
    appInstance: {
      type: String,
      required: false,
    }
  },

  methods: {
    mapChartData() {
      let factor = 100 / this.product.prices[this.product.product.underlying].prices[0].close
      let factor2 = 100 / this.product.prices[this.product.product.dq].prices[0].close
      return {
        labels: this.product.prices[this.product.product.underlying].prices.map(el => {
          return this.moment(el.localDate, 'YYYY-MM-DD').format()
        }),
        datasets: [
          {
            label: this.product.product.name + '         ',
            borderColor: this.environment === 'hauck' ? '#1A4AA0' : 'blue',
            fill: false,
            lineTension: 0,
            borderJoinStyle: 'round',
            backgroundColor: 'rgba(0,0,0,0)',
            pointRadius: 0,
            data: this.product.prices[this.product.product.underlying].prices.map(price => {
              let searchResult = this.product.prices[this.product.product.dq].prices.find(needle => {
                return price.localDate === needle.localDate
              })

              let value = this._.get(searchResult, 'close', null)
              if (value) {
                return value * factor2
              }
            })
          },
          {
            label: this.product.product.derived.underlying.name + ' (relativ)',
            borderColor: this.environment === 'hauck' ? '#739932' : 'red',
            backgroundColor: 'rgba(0,0,0,0)',
            lineTension: 0,
            borderJoinStyle: 'round',
            borderDash: [15, 5],
            fill: false,
            pointRadius: 0,
            data: this.product.prices[this.product.product.underlying].prices.map(el => {
              return el.close * factor
            })
          }
        ]
      }
    }
  },



  async created() {

    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }

    let options = []
    if (this.$route.query.date) {
      options.push(
        {
          name: 'date',
          value: this.$route.query.date
        }
      )
    }
    if (this.$route.query.quote) {
      options.push(
        {
          name: 'quote',
          value: this.$route.query.quote
        }
      )
    }
    ProductService.getProductForReport(
      this.environment,
      this.appInstance,
      this.dq,
      this.token,
      options
    ).then(res => {
      this.product = res.data.data

      if (this.dq === 'QP00DE000LB1E9Z2') {
        this.product = ProductService.extrawurst.data
      }

      this.chartData = this.mapChartData()
      console.log(this.chartData)
      ConfigService.getDocumentConfig(
        this.environment,
        'report',
        this.product.product.derived.market.toLowerCase(),
        this.product.product.type
      ).then(result => {
        this.template = new TemplateService(result.data)

        this.tables = new TableCollection(
          new Table(
            'upcoming-events',
            this.template.futureEvents(),
            this._.get(this.product, 'added.typeSpecific.events', []).filter(el => {
              return !el.past
            }),
            TableReportEvents,
            'Zukünftige Ereignisse'
          ),
          new Table(
            'past-events',
            this.template.pastEvents(),
            this._.get(this.product, 'added.typeSpecific.events', []).filter(el => {
              return el.past
            }),
            TableReportEvents,
            'Bisherige Ereignisse'
          )
        )

      })

    })

  }

}
</script>



// WEBPACK FOOTER //
// Report.vue?2b4811ea